import React from "react";
import Picture from "../components/common/Picture";
import {HeroImageSection} from "../components/common/HeroImageSection";
import {useModal} from "../components/context/ModalContext";

const WhereAndCharterSection: React.FC = () => {
    return (
        <section
            id="where-section"
            className="snap-section h-auto flex flex-col">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl text-center py-8 sm:py-12">
                <h2 className={`heading-font text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-tight px-2 text-ivory mb-6 sm:mb-8`}>
                    Charter
                </h2>
                <p className="text-sm sm:text-base lg:text-lg leading-relaxed px-2 lg:px-0">
                    The All Aces club is an exclusive By-Invitation only, private member’s club envisioned by the
                    group of self driven professionals with a penchant for excellence and a flair for hospitality.
                    The club is Designed as a family, sports, recreation and lifestyle facility.
                    <br/><br/>
                    It is our endeavour to elevate the lifestyle experiences of Faridabad’s elites and establish a
                    new benchmark in luxury and elegance.
                </p>
            </div>
            <div className="flex flex-col min-h-0 md:flex-row flex-1 bg-ivory text-royal-pine">
                <div className="md:w-1/2 overflow-hidden h-64 md:h-auto relative">
                    <Picture
                        webpSrc="/images/culinary_banner.webp"
                        alt="All Aces Club Location Drone Shot"
                        className="absolute inset-0 w-full h-full object-cover"
                        onErrorSrc={'https://placehold.co/1920x1080/153D40/C6A375?text=All+Aces+Club'}
                    />
                </div>
                <div className="md:w-1/2 flex items-center justify-center py-8 sm:py-12 px-4 sm:px-6 lg:px-8">
                    <div className="max-w-xl text-center md:text-left">
                        <h2 className="heading-font text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-tight mb-4">
                            Where
                        </h2>
                        <p className="text-sm sm:text-base lg:text-lg leading-relaxed mb-4">
                            “Not more than 10 minutes away” — that was our guiding principle from the very beginning.
                            From the very first day of our land search, we knew that to be close to your hearts, we
                            needed to be close your homes. With this in mind, we imagined a place that was not far and
                            close enough to become a part of your daily routine. This clear vision and our persistent
                            efforts culminated in us finding a piece of land that just felt right.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

const ApproachSection: React.FC = () => {
    return (
        <section
            className="snap-section flex items-center bg-dark-mode text-ivory flex-col py-8 sm:py-12 lg:py-20">
            <div className="container my-auto mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl text-center">
                <h2 className={`heading-font text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-tight px-2 text-ivory mb-6 sm:mb-8`}>
                    Approach
                </h2>
                <p className="text-sm sm:text-base lg:text-lg leading-relaxed px-2 lg:px-0 mb-4">
                    Conceptualised and brought to life by Vivek Logani & Associates – Renowned leader in contemporary  architecture.  Spanning across more than two acres of land in center of city, All Aces Club unfolds over five artfully linked levels, encompassing more than 1,50,000 sq. ft. Every element will be crafted to embody sophistication, functionality, and timeless design.
                </p>
                <p className="text-sm sm:text-base lg:text-lg leading-relaxed px-2 lg:px-0 mb-4">
                    From welcoming lounges to vibrant restaurants, café and bar, every corner reflects the highest levels of hospitality, ensuring members feel cared for, connected, and at home.
                </p>
                <p className="text-sm sm:text-base lg:text-lg leading-relaxed px-2 lg:px-0 mb-4">
                    At its heart, the club we strive for, is a community — a place where people come together to laugh, celebrate, and grow, creating bonds that feel natural and lasting.
                </p>
                <p className="text-sm sm:text-base lg:text-lg leading-relaxed px-2 lg:px-0">
                    Our vision of this community goes far beyond the gates of the club. It is about nurturing a spirit of togetherness that inspires us to celebrate, explore, and journey side by side. From intimate gatherings to adventurous trekking expeditions, every experience will be thoughtfully created to deepen connections and build memories that last a lifetime.
                </p>
            </div>
        </section>
    );
};

const WhoSection: React.FC = () => {
    const {openDesignerModal} = useModal();

    const ceos = [
        {
            name: 'Sushant Goenka',
            role: 'Founder',
            image: "/images/sushant_goenka.png"
        },
        {
            name: 'Nipun Grover',
            role: 'Co-Founder',
            image: "/images/nipun_grover.jpg"
        },
        {
            name: 'Shashank Dutt Sharma',
            role: 'Co-Founder',
            image: "/images/shashank_dutt_sharma.jpg"
        },
    ];

    return (
        <section
            className="snap-section h-auto flex items-center bg-ivory text-royal-pine flex-col py-8 sm:py-12 lg:py-20">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
                <div className="text-center mb-6 sm:mb-8 lg:mb-12">
                    <h2 className="heading-font text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-tight px-2">
                        Who
                    </h2>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
                    {ceos.map((designer, index) => (
                        <div
                            key={index}
                            className={
                                `bg-white rounded-lg p-6 text-center shadow-lg transition-transform hover:scale-105 ` +
                                (index === 0 ? `sm:col-span-2` : ``)
                            }
                        >
                            <Picture
                                {...(designer.image.toLowerCase().endsWith('.webp') ? { webpSrc: designer.image } : designer.image.toLowerCase().endsWith('.png') ? { pngSrc: designer.image } : { jpgSrc: designer.image })}
                                alt={designer.name}
                                className="rounded-full w-24 h-24 mx-auto mb-4 object-cover"
                                onErrorSrc={'https://placehold.co/150x150/153D40/C6A375?text=Designer'}
                            />
                            <h3 className="heading-font text-xl font-semibold mb-2">{designer.name}</h3>
                            <p className="text-sm text-gray-600">{designer.role}</p>
                            <button onClick={() => openDesignerModal(designer)}
                                    className="mt-4 inline-block text-logo-color font-medium hover:underline">
                                Read more
                            </button>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

const AboutPage: React.FC = () => {
    return (
        <div className="bg-dark-mode text-ivory">
            {/* Hero Section */}
            <HeroImageSection
                image="/images/about_banner.webp"
                text="About All Aces Club"
                nextSectionId="club-charter-section"
            />

            {/* Where and Charter Section */}
            <WhereAndCharterSection/>

            {/* Approach Section */}
            <ApproachSection/>

            {/* Who Section */}
            <WhoSection/>
        </div>
    );
};

export default AboutPage;
